import { Observable } from '../../Observable';
import { onErrorResumeNext } from '../../operator/onErrorResumeNext';

Observable.prototype.onErrorResumeNext = onErrorResumeNext;

declare module '../../Observable' {
  interface Observable<T> {
    onErrorResumeNext: typeof onErrorResumeNext;
  }
}


// WEBPACK FOOTER //
// ../../../src/add/operator/onErrorResumeNext.ts